import {types} from './types';

const initialState = {
    amount: {
        amount: 0,
        referrer_amount: 0
    },
    list: {
        data: [],
        countPage: 1,
    },
    view: {
        data: [],
        countPage: 1
    }
}

export function referralsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_AMOUNT:
            return { ...state, amount: action.payload};
        case types.SET_REFERRALS:
            return { ...state, list: action.payload};
        case types.SET_REFERRAL_INFO:
            return { ...state, view: action.payload}
        default:
            return state
    }
}